<template>
  <div>
    <!-- 卖场轮播图开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <p class="actModules_descripe" v-html="modulesRules"></p>
      <div class="swiper-container sellBanner">
        <swiper
          class="swiper-wrapper"
          :options="swiperOption"
          ref="mySwiper"
          @someSwiperEvent="callback"
        >
          <template v-for="(bannerImg, index) in bannerImgs">
            <swiper-slide
              v-if="!!bannerImg.img.value && bannerImg.img.value !== ''"
              class="swiper-slide"
              :key="index"
            >
              <img
                @click="gotodetail(bannerImg.url)"
                :src="bannerImg.img.value"
                :indexurl="bannerImg.url"
              />
            </swiper-slide>
          </template>
        </swiper>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
    </div>
    <!-- 卖场轮播图结束-->
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import './../../assets/css/reset.css';
export default {
	name: 'h5-intro',
	components: {
		swiper,
		swiperSlide
	},
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '游戏介绍标题',
			modulesRules: '游戏介绍简介',
			bannerImgs: '轮播图',
			img: '图片链接',
			url: '点击图片跳转链接'
		}
	},
	props: {
		modulesTitle: {
			type: String,
			default: '游戏介绍标题'
		},
		modulesRules: {
			type: String,
			default: '游戏介绍简介'
		},
		bannerImgs: {
			type: Array,
			default: function () {
				return [
					{
						img: {
							class: 'image',
							value: ''
						},
						url: ''
					},
					{
						img: {
							class: 'image',
							value: ''
						},
						url: ''
					},
					{
						img: {
							class: 'image',
							value: ''
						},
						url: ''
					},
					{
						img: {
							class: 'image',
							value: ''
						},
						url: ''
					},
					{
						img: {
							class: 'image',
							value: ''
						},
						url: ''
					}
				];
			}
		}
	},
	computed: {
		swiper () {
			return this.$refs.mySwiper.swiper;
		}
	},
	data () {
		return {
			swiperOption: {
				loop: true,
				autoplay: true,
				pagination: {
					el: '.swiper-pagination'
				}
			}
		};
	},
	mounted () {},
	methods: {
		gotodetail (_url) {
			if (typeof _url !== 'undefined' && _url !== '') {
				window.location.href = _url;
			}
		},
		callback () {
			console.log('1');
		}
	}
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/common";
.sellBanner {
  width: 7.3rem;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.actModules_descripe {
  font-size: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/introduce/introduce.vue